module.exports = __webpack_public_path__ + "img/72.96e208e8.jpg";